import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { ApplicationCompany } from '../../models/applicationCompany.model';
import { Company } from '../../models/company.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class CompaniesService {
  companies: Company[];
  applications: ApplicationCompany[];
  companyEditing: Company;
  private cachedFields: Observable<any>;
  private cachedFieldsApp: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService ) {
      this.companies = [];
      this.applications = [];
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Company>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.get('/koncentro-auth/companies?' + params.toString());
  }

  getAll() {
    return this.h.get('/koncentro-auth/companies')
      .map(res => {
        return this.companies = res;
      });
  }

  getUserCompanies(userId: number) {
    return this.h.get('koncentro-auth/users/user_companies/'+ userId);
  }

  delete(record) {
    return this.h.delete('/koncentro-auth/companies/' + record.id)
      .map(res => {
        this.companies.splice(this.companies.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Company deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-auth/companies/', newData)
      .map(res => {
        newData.id = res.id;
        this.companies.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  put(newData) {
    return this.h.put('/koncentro-auth/companies/', newData)
      .map(res => {
        // Object.assign(this.companyEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getApplications(c: Company) {
    return this.h.get('/koncentro-auth/companies/company_applications/' + c.id)
      .map(res => {
        return this.applications = res;
      });
  }

  getApplicationsFromUser(companyId: number) {
    return this.h.get(`/koncentro-auth/companies/company_applications/${companyId}`);
  }

  postApplication(a: ApplicationCompany) {
    return this.h.post('/koncentro-auth/companies/company_applications/', a)
      .map(res => {
        a.id = res.id;
        // this.applications.push(a);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  putApplication(a: ApplicationCompany) {
    return this.h.put('/koncentro-auth/companies/company_applications/' + a.id, a)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  deleteApplication(a: ApplicationCompany) {
    return this.h.delete('/koncentro-auth/companies/company_applications/' + a.id)
      .map(res => {
        this.applications.splice(this.applications.findIndex(uc => uc.id === a.id), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Application deleted'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-auth/schema/CompanyDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getFieldsApp() {
    if (!this.cachedFieldsApp) {
      this.cachedFieldsApp = this.h.get('/koncentro-auth/schema/ApplicationCompanyDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFieldsApp;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/company/companies.service.ts